module.exports = __webpack_public_path__ + "static/media/hour-glass.7ada913b.png";